module.exports = __webpack_public_path__ + "media/media/home/_img3-87fa4b064662c53a363dcc2c1dc6a989.png";